
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getQaConfigsForRegion",
      resolverType: "query",
      routePath: "/getQaConfigsForRegion",
      httpMethod: "POST",
    });
  